export default {
  path:'/verify',
  preload:false,
  middlewares: []
}
